import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { usePerms } from 'contexts/PermsContext';
import AirportDelays from 'features/Weather/features/SpecialReports/features/AirportDelays/index.web';
import FireDanger from 'features/Weather/features/SpecialReports/features/FireDanger/index.web';
import SkiReports from 'features/Weather/features/SpecialReports/features/SkiReports/index.web';
import Earthquakes from 'features/Weather/features/WeatherMaps/features/Earthquakes/index.web.jsx';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TabsHeader from '../../components/TabsHeader/TabsHeader';

export default function SpecialReports() {
  const [params] = useSearchParams();
  const perms = usePerms();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions(['SpecialReportsEnabled']))) {
        navigate('/404');
        return;
      }
    })();
  }, []);

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'fire danger':
        return <FireDanger />;
      case 'earthquake reports':
        return <Earthquakes />;
      case 'ski reports':
        return <SkiReports />;
      case 'airport delay':
        return <AirportDelays />;

      default:
        return <FireDanger />;
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100 py-3">
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader
          options={[
            { option: 'Fire Danger' },
            { option: 'Earthquake Reports' },
            { option: 'Ski Reports' },
            { option: 'Airport Delay' },
          ]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      <div className="d-block d-lg-none">
        <MobileTabsHeader
          options={[
            { option: 'Fire Danger' },
            { option: 'Earthquake Reports' },
            { option: 'Ski Reports' },
            { option: 'Airport Delay' },
          ]}
        />
      </div>
      {/* content */}
      <div
        style={{
          height: 'calc(100% - 48px)',
        }}
      >
        {renderTab()}
      </div>
    </Container>
  );
}
